//App Type Constants
export const APPLICANT_TYPE_MENTEE = 1
export const APPLICANT_TYPE_MENTOR = 2
export const APPLICANT_TYPE_COMMITTEE = 3
export const APP_TYPE_ID_TO_STRING = {
  1: "Mentee",
  2: "Mentor",
  3: "Committee Member",
};
//App Status Constants
export const APPLICATION_STATUS_ID_PENDING = 1
export const APPLICATION_STATUS_ID_SUBMITTED = 2
export const APPLICATION_STATUS_ID_WITHDRAWN = 3
export const APPLICATION_STATUS_ID_ACCEPTED = 4
export const APPLICATION_STATUS_ID_REJECTED = 5
export const APPLICATION_STATUS_ID_DRAFT = 7
export const APPLICATION_STATUS_ID_WAITLISTED = 8
export const APPLICATION_STATUS_ID_DECLINED = 9
//Essay Constants
export const ESSAY_MAX_WORD_COUNT = 600;
export const local_ESSAY_APPROX_WORD_COUNT = 500; //used locally in CONSTANTS variable ESSAY PROMPT
export const ESSAY_PROMPT = `In 500 words or fewer, tell us why you want to participate in the CLEAR program. What do you hope to gain from the experience, and what will you contribute to your peers? Please review your response with your manager before submitting.`

//Competencies Constants
export const COMPETENCIES_MENTEE_INFO = "Rate yourself in each skill area below. Be honest — rating a skill lower tells us where you'd like to grow, and helps us match you with the right mentor.";

export const COMPETENCIES_MENTOR_INFO = "Rate yourself in each skill area below. Rating a skill higher tells us where you're strongest and ready to guide others — this helps us match you with a mentee who will benefit most.";

export const COMPETENCIES_COMMITTEE_MEMBER_INFO = "Rate yourself in each skill area below. This helps us build balanced triads by matching your strengths with your mentor and mentee.";

export const COMPETENCIES_ADDITIONAL_SKILLS_PROMPT = "Use this space to tell us more about yourself \u2014 share examples of the skills above, highlight additional strengths, or describe what you're hoping to develop.";

// Skill rating labels and colors (index 0 = rating value 1)
export const RATING_LABELS = [
  'Very Weak',
  'Weak',
  'Slightly Weak',
  'Slightly Strong',
  'Strong',
  'Very Strong',
];

// Categorical data-visualisation palette for competency ratings. These are
// encodings, not theme surfaces, so they stay fixed across themes.
export const RATING_COLORS = [
  '#d32f2f', // Very Weak — red
  '#e65100', // Weak — deep orange
  '#f9a825', // Slightly Weak — amber
  '#7cb342', // Slightly Strong — light green
  '#388e3c', // Strong — green
  '#1b5e20', // Very Strong — dark green
];


